import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/menu/cardFactories/categories/menuCategoryAssignedSubcategoriesFactory.ts
var getMenuCategorySubcategoryMenuTypeElements = (subcategoryMenuTypeElementIds) => {
  const elementSet = /* @__PURE__ */ new Set();
  Object.values(subcategoryMenuTypeElementIds).forEach((menuTypeElementIds) => {
    Object.values(menuTypeElementIds).forEach((elementIds) => {
      elementIds.forEach((elementId) => {
        elementSet.add(elementId);
      });
    });
  });
  return Array.from(elementSet);
};
var getMenuCategoryMenuTypeElements = (menuTypeElementIds) => {
  const elementSet = /* @__PURE__ */ new Set();
  Object.values(menuTypeElementIds).forEach((elementIds) => {
    elementIds.forEach((elementId) => {
      elementSet.add(elementId);
    });
  });
  return Array.from(elementSet);
};
var menuCategoryAssignedSubcategoriesFactory = (categoryName, subcategories, subcategoryIds, subcategoryMenuTypeItemsIds, subcategoryMenuTypeCombosIds, handleDeleteSubcategory) => {
  return subcategoryIds.map((subcategoryId) => {
    var _a, _b, _c, _d;
    const itemsArray = getMenuCategoryMenuTypeElements(
      subcategoryMenuTypeItemsIds[subcategoryId] || {}
    );
    const combosArray = getMenuCategoryMenuTypeElements(
      subcategoryMenuTypeCombosIds[subcategoryId] || {}
    );
    const subcategory = subcategories[subcategoryId];
    const status = subcategory ? subcategory.active : true;
    return {
      id: (subcategory == null ? void 0 : subcategory.id) || 0,
      title: (subcategory == null ? void 0 : subcategory.name) || `${categoryName} - ${i18n_config_default.t("commonTexts.other")}`,
      customTag: `${i18n_config_default.t("components.menuCard.tag.itemCount", {
        count: (_a = itemsArray.length) != null ? _a : 0
      })} | ${i18n_config_default.t("components.menuCard.tag.comboCount", {
        count: (_b = combosArray.length) != null ? _b : 0
      })}`,
      itemCount: (_d = (_c = itemsArray.length) != null ? _c : 0 + combosArray.length) != null ? _d : 0,
      categoryId: (subcategory == null ? void 0 : subcategory.categoryId) || 0,
      status,
      isStatusActive: status,
      activeFilter: subcategory ? subcategory.active ? 1 : 2 : 1,
      onPress: () => null,
      onDelete: handleDeleteSubcategory
    };
  });
};

export { getMenuCategoryMenuTypeElements, getMenuCategorySubcategoryMenuTypeElements, menuCategoryAssignedSubcategoriesFactory };
